/*eslint-disable*/
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../../Assests/Globalcss/stylesheet.css";
import banner_img from "../../Assests/Globalimages/banner-image.png";
import cleansing from "../../Assests/bannerCategories/clean.png";
import mosturizing from "../../Assests/bannerCategories/mois.png";
import anti_aging from "../../Assests/bannerCategories/anti-ag.png";
import reviews from "../../Assests/customImages/reviews.png";
// import soothing from "../../Assests/Globalimages/nature1 (10).png";
import arrival_bloom1 from "../../Assests/Globalimages/bloom (1).png";
import arrival_bloom2 from "../../Assests/Globalimages/bloom (2).png";

import will_get1 from "../../Assests/customImages/will-get-one.png";
import will_get2 from "../../Assests/customImages/will-get-two.png";

import will_get3 from "../../Assests/customImages/will-get-three.png";

import soothing from "../../Assests/bannerCategories/soth.png";
import card1 from "../../Assests/Globalimages/DSC_0037 1.png";
import card2 from "../../Assests/Globalimages/arrivel-image (3).png";
import card3 from "../../Assests/Globalimages/arrivel-image (1).png";
import card4 from "../../Assests/Globalimages/arrivel-image (5).png";
import img_goat from "../../Assests/Globalimages/Rectangle.png";
import best_img1 from "../../Assests/Globalimages/best-image (1).png";
import best_img2 from "../../Assests/Globalimages/best-image (2).png";
import best_img3 from "../../Assests/Globalimages/best-image (3).png";
import nature16 from "../../Assests/Globalimages/nature1 (16).png";
import profiletes from "../../Assests/Globalimages/profile-tes.png";
import arrival1 from "../../Assests/new-arrivals/arrival1.png";
import arrival2 from "../../Assests/new-arrivals/arrival2.png";

import arrival3 from "../../Assests/new-arrivals/arrival3.png";
import arrival4 from "../../Assests/new-arrivals/arrival4.png";


import swiper_slider_img from "../../Assests/Globalimages/slider_image.jpeg";
import Navbar from "../../Componenets/Navbar";
import Footer from "../../Componenets/Footer";
import { Link, useNavigate } from "react-router-dom";
import ProductCard from "../../Componenets/ProductCard/ProductCard";
import { fetchProducts } from "../../Redux/Products/productSlice";
import { useDispatch, useSelector } from "react-redux";



const index = () => {
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(fetchProducts({page : 1 , limit : 1000}))
  },[]);
  const testimonials = [
    {
      id: 1,
      text: "If you are looking for soap that is not only pretty, unique, and wonderfully scented, then Lynn Martin's My Favorite Things luxurious handmade soaps are for you. I've been using her beautifully crafted creations for years. They add a nice accent to one's bathroom and make lovely gifts to give.",
      author: "Adrienne Birchler"
    },
    {
      id: 2,
      text: "I have used 'My Favorite Things' Chamomile Sugar Scrub and it is so nice. It leaves your skin soft and smooth by gently exfoliating with sugar crystals. No more rough skin.",
      author: "Lisa"
    },
    {
      id: 3,
      text: "My Favorite Things soaps and products are high quality and the scents are amazing. I have been a customer for several years now and have never been disappointed. The soaps are pure and soothing to the skin. I love the pretty decorative designs on the soaps that are enjoyable to look at as they are excellent to use. Recently, I received a beautiful jar of potpourri from Lynn, the owner of My Favorite Things. It has a wonderful fragrance that fills the room with a light aroma of warm scents, which is especially nice and enjoyable as we go through these days of winter.",
      author: "Linda P."
    },
    {
      id: 4,
      text: "Looks Amazing.",
      author: "Happy Customer"
    }
  ];

  const {products} = useSelector((state)=> state.products);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 

  return (
    <div>
      
      <section class="banner">
        <div class="container">
          <div class="row d-flex align-items-center">
            <div class="col-lg-6 ">
              <div class="content-banner-text">
                <h1>Handmade soap & soap products</h1>
                <p style={{fontWeight:400}}>
                Pure Organic and best milk goat’s made soaps to help your screen stay moisture and soothing with surprising  {isDesktop && <br />} Shop with us today!
                </p>
                <div  >
                  <button onClick = {()=>navigate('/shop')} class="shop-btnnn ">Shop Now</button>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="content-bannere-img">
                <img src={banner_img} class="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- new sectionis started  --> */}
      <section class="first-section">
        <div class="container">
          <div class="row">
            <div class="four_small_card">
              <div class="main_shipping-text">
                <img src={cleansing} alt="" />
                <div class="shipping-text">
                  <h6>Cleansing</h6>
                </div>
              </div>
              <div class="main_shipping-text main_shipping-text1">
                <img src={mosturizing} alt="" />
                <div class="shipping-text">
                  <h6>Moisturizing</h6>
                </div>
              </div>
              <div class="main_shipping-text main_shipping-text1">
                <img src={anti_aging} alt="" />
                <div class="shipping-text">
                  <h6>Anti-aging</h6>
                </div>
              </div>
              <div class="main_shipping-text main_shipping-text1">
                <img src={soothing} alt="" />
                <div class="shipping-text">
                  <h6>Soothing</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="Arrival_section">
        <div class="container">
          <div class="row">
            <div class="shope_now">
              <img src={arrival_bloom2} alt="" />
              <h4>NEW ARRIVALS</h4>
              <img src={arrival_bloom1} alt="" />
            </div>
            {/* <div class="see_all_text">
              <p>see all</p>
            </div> */}

            {products?.filter((item)=>item.category == 'new_arrivals').map((product) => (
             < ProductCard product={product}/> 
            ))}
           
          </div>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:20}}>
      <button
        onClick={() => navigate("/Shop")}
       class="shop-btnnn " 
       style={{border: '3px solid #F5A3B7'}}
      >
        Shop Now ↗ 
      </button>
    </div>
        </div>
      </section>
      <section class="goats-milks">
        <div class="container">
          <div class="row d-flex justify-content-center  align-items-center">
            <div class="col-lg-6 position-relative">
              <div class="img-goats">
                <img src={img_goat} class="img-fluid" alt="" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="content-text-goat">
                <h3>About Goat's Milk</h3>
                <p class="fresh">Fresh, Pure, and Always Natural.</p>
                <p class="para-goat">
                  Goat's milk is a very mild soap that lathers up well and is
                  one of the very best soaps you can get. I have a small line of
                  men's products as well as many other products that you may be
                  interested in such as potpourri sachets, sugar scrubs, travel
                  soaps and bath salts. I appreciate your interest in my soaps.
                </p>
                <div class="button-goat">
                <div class="btn-shope">
                  <button onClick = {()=>navigate('/shop')} class="shop-btnnn ">Shop Now</button>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="Arrival_section">
        <div class="container">
          <div class="row">
            <div class="shope_now">
              <img src={arrival_bloom2} alt="" />
              <h4>Best selling</h4>
              <img src={arrival_bloom1} alt="" />
            </div>
            <div class="see_all_text">
              <Link to={'/Shop'} style={{textDecoration:'none'}}>
         
              <p style={{cursor: 'pointer', textDecoration:'none'}}>see all</p>
              </Link>
            </div>
            {products?.filter((item)=>item.category == 'best_selling').map((product) => (
             < ProductCard product={product}/> 
            ))}
          
          </div>
        </div>
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop : '20px'}}>
      <button
        onClick={() => navigate("/Shop")}
       class="shop-btnnn " 
       style={{border: '3px solid #F5A3B7' , marginBottom : '1rem'}}
      >
        Shop Now ↗ 
      </button>
    </div>
      </section>
      
      <section class="hand-made">
        <div class="container">
          <div class="row d-flex justify-content-end">
            <div class="col-lg-7"></div>
            <div class="col-lg-5">
              <div class="contante-hand-made">
                <h6>New collection</h6>
                <h1>Handmade with Love, Powered by Nature.</h1>
                <p>
                Discover our latest soaps, crafted with care using nature’s finest ingredients.
                  <br />
                </p>
                <div class="button-handmade mt-3">
                  <button onClick = {()=>navigate('/shop')} type="button" class="btn-lg shop-now-hand">
                    Shop Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="slider-section " style={{background:'#F5A3B730'}}>
        <div class="container">
         
          <div class="shope_now">
              <img src={arrival_bloom2} alt="" />
              <div class="heading-swiper d-flex justify-content-center">
              <h1 className="">
              What our <span class="customer">customer</span> says
            </h1>
          </div>
              <img src={arrival_bloom1} alt="" />
            </div>
           
          <div class="swiper mySwiper">
            <div class="swiper-wrapper" style={{margin: '0px 10px'}}>
            <Slider {...settings}>
            {testimonials?.map((item, index) => (
              <div key={item.id || index} className="slider-content">
                <div className="star-slider d-flex">
                  <img src={nature16} className="img-fluid starts" alt="star" />
                  <img src={nature16} className="img-fluid starts" alt="star" />
                  <img src={nature16} className="img-fluid starts" alt="star" />
                  <img src={nature16} className="img-fluid starts" alt="star" />
                </div>
                <div className="para-slider">
                  <p style={{fontSize: 12.5, fontWeight: 500, padding: "0px 25px"}}>
                    "{item.text}"
                  </p>
                </div>
                <h6 style={{fontSize: 16, textAlign: 'center'}}>
                  — {item.author}
                </h6>
              </div>
            ))}
        </Slider>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </section>

      <section class="free_shepping_section" style={{background:'white',marginTop:115}}>
        <div class="container">
          <div class="row d-flex justify-content-center"  >
            <div class="shope_now" style={{}}>
              <img src={arrival_bloom2} alt="" />
              <h4 style={{textTransform:'capitalize'}}>you will get</h4>
              <img src={arrival_bloom1} alt="" />
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get1} alt="" />
                              <h4 style={{fontSize:20, fontWeight:600}}>Season Sale</h4>
                <p >
                Pamper your skin for less! Enjoy special seasonal discounts on our handcrafted goat milk soaps. Treat yourself or someone you love to nourishing skincare at unbeatable prices. Shop now your skin will thank you!
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get2} alt="" />
                <h4 style={{fontSize:20, fontWeight:600}}> Shipping</h4>
                <p >
                We know you can’t wait to experience the goodness of our goat milk soap. That’s why we offer quick and secure shipping straight to your door with tracking available on every order.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="season_text">
              <img src={will_get3} alt="" />

                <h4 style={{fontSize:20, fontWeight:600}}>Money Back Gurantee</h4>
                <p >
                We care about happy skin and happy customers! If you're not completely satisfied with our soap, we offer a full money-back guarantee. Shop with confidence your satisfaction is our promise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default index;
